module.exports = __webpack_public_path__ + "img/mengjinqu.58185847.png";